import Vue from "vue";
import axios from "axios";
import util from "./util";
import basedata from "./basedata";
import qs from "qs";
import { Toast } from "vant";
import api from "../services/api";
Vue.use(Toast);

let vm = new Vue();

function post(url, data = {}, that, isFirst, callback) {
  let Addurl = "";
  // if(url == 'Authorize/GetCustomerApplyInfo'){
  // 	Addurl = 'http://192.168.0.49:116/api/Authorize/GetCustomerApplyInfo';
  // }else{
  Addurl = basedata.postUrl + url;
  // }
  if (!!util.getStoObj("allinfo")) {
    // data.PlatformType = util.getStoObj('allinfo').PlatformType;
    // data.ADS_UserId = util.getStoObj('allinfo').ADS_UserId;
    // data.IsLogin = !!util.getStoObj('allinfo').Eshop_Mobile ? '1':'0';
    // data.OrdHelperMemId = util.getStoObj('allinfo').OrdHelperMemId;
    // data.OrdHelperToken = util.getStoObj('allinfo').OrdHelperToken;
    // data.QRcode_Type = 3;
    // data.ShareActivityId = 0;
    // data.ShareUserId = 0;
    if (url == "Ca_AcProducts/GetAcProductListBySearch") {
      data.ShopCode = util.getStoObj("allinfo").ShopCode;
      data.Mobile = util.getStoObj("allinfo").Eshop_Mobile;
    }
  }
  return new Promise((resolve, reject) => {
    // util.showLoad()
    if (that) {
      that.loadShow = true;
    }

    axios
      .post(Addurl, data)
      .then((res) => {
        if (!!res.data.Data.NewToken) {
          var allinfo = util.getStoObj("allinfo");
          if (allinfo) {
            allinfo.OrdHelperToken = res.data.Data.NewToken;
          }
          util.setStoObj("allinfo", allinfo);
        } else if (!!res.data.NewToken) {
          var allinfo = util.getStoObj("allinfo");
          if (allinfo) {
            allinfo.OrdHelperToken = res.data.NewToken;
          }
          util.setStoObj("allinfo", allinfo);
        } else if (!!res.data.Data.OrdHelperToken) {
          var allinfo = util.getStoObj("allinfo");
          if (allinfo) {
            allinfo.OrdHelperToken = res.data.Data.OrdHelperToken;
          }
          util.setStoObj("allinfo", allinfo);
        }
        if (res.data.ResultType === 1) {
          if (that) {
            that.loadShow = false;
          }

          if (url == "Ca_AcProducts/GetAcProductListBySearch") {
            var res = res.data.Data;
            var listArr = [];
            if (
              that.pageData.postUrl == "Ca_AcProducts/GetAcProductListBySearch"
            ) {
              // 订购商品
              if (
                that.pageData.params.SearchProductType == 1 ||
                that.pageData.params.SearchProductType == 2 ||
                that.pageData.params.SearchProductType == 5 ||
                that.pageData.params.SearchProductType == 6 ||
                that.pageData.params.SearchProductType == 7 ||
                that.pageData.params.SearchProductType == 8
              ) {
                for (var i = 0; i < res.ProductInfo_Comm_List.length; i++) {
                  if (res.ProductInfo_Comm_List[i].ImgUrl != null) {
                    res.ProductInfo_Comm_List[
                      i
                    ].ImgUrl = res.ProductInfo_Comm_List[i].ImgUrl.split(
                      ","
                    )[0];
                  }
                }
                listArr = res.ProductInfo_Comm_List;
              } else if (that.pageData.params.SearchProductType == 3) {
                listArr = res.TopTenHotProductName_List;
              } else if (that.pageData.params.SearchProductType == 4) {
                listArr = res.ProductInfo_KeyWord_List;
              }
              that.ShenHeStatus = res.ShenHeStatus;
              util.setSto("ShenHeStatus", res.ShenHeStatus);
              that.IsADS = res.IsADS;
            } else {
              listArr = res.data.Data.infoList;
            }

            if (isFirst) {
              that.pageData.infoList = listArr;
              if (that.pageData.infoList.length < 4) {
                that.pageData.isLoading = false;
              }
            } else {
              that.pageData.infoList = that.pageData.infoList.concat(listArr);
            }
            that.pageData.TotalPage = res.TotalPage == 0 ? 1 : res.TotalPage;
            that.pageData.totalNum = res.TotalCount;
            if (that.pageData.params.CurrentPage <= that.pageData.TotalPage) {
              that.pageData.params.CurrentPage++;
            }

            for (let i in res) {
              if (
                i == "infoList" ||
                i == "StoreFromList" ||
                i == "CurrentPage" ||
                i == "TotalPage"
              ) {
              } else {
                that.pageData[i] = res[i];
              }
            }
            if (callback) {
              callback();
            }
          } else {
            resolve(res.data.Data);
          }
        } else {
          if (that) {
            that.loadShow = false;
            that.$parent.Loading(false);
          }

          if (that.surePaySuccess) {
            that.surePaySuccess = false;
          }
          reject(res.data.Data);
          Toast(res.data.Message);
        }
        // setTimeout(() => {
        // util.hideLoad()
        // }, 400);
      })
      .catch((err) => {
        if (that) {
          that.loadShow = false;
        }

        // util.hideLoad()
        reject(err);
        // Toast('网络异常')
      });
  });
}

function postTwo(url, data = {}, that, isFirst, callback) {
  let Addurl = "";
  // if(url == 'Authorize/GetCustomerApplyInfo'){
  // 	Addurl = 'http://192.168.0.49:116/api/Authorize/GetCustomerApplyInfo';
  // }else{
  Addurl = sessionStorage.getItem("QPT_DomainUrl") + url;
  // }
  if (!!util.getStoObj("allinfo")) {
    // data.PlatformType = util.getStoObj('allinfo').PlatformType;
    // data.ADS_UserId = util.getStoObj('allinfo').ADS_UserId;
    // data.IsLogin = !!util.getStoObj('allinfo').Eshop_Mobile ? '1':'0';
    // data.OrdHelperMemId = util.getStoObj('allinfo').OrdHelperMemId;
    // data.OrdHelperToken = util.getStoObj('allinfo').OrdHelperToken;
    // data.QRcode_Type = 3;
    // data.ShareActivityId = 0;
    // data.ShareUserId = 0;
  }
  return new Promise((resolve, reject) => {
    // util.showLoad()
    if (that) {
      that.loadShow = true;
    }

    axios
      .post(Addurl, data, {
        headers: {
          Token: sessionStorage.getItem("QPT_UserToken"),
        },
      })
      .then((res) => {
        if (!!res.data.Data.NewToken) {
          var allinfo = util.getStoObj("allinfo");
          if (allinfo) {
            allinfo.OrdHelperToken = res.data.Data.NewToken;
          }
          util.setStoObj("allinfo", allinfo);
        } else if (!!res.data.NewToken) {
          var allinfo = util.getStoObj("allinfo");
          if (allinfo) {
            allinfo.OrdHelperToken = res.data.NewToken;
          }
          util.setStoObj("allinfo", allinfo);
        } else if (!!res.data.Data.OrdHelperToken) {
          var allinfo = util.getStoObj("allinfo");
          if (allinfo) {
            allinfo.OrdHelperToken = res.data.Data.OrdHelperToken;
          }
          util.setStoObj("allinfo", allinfo);
        }
        if (res.data.ResultType === 1) {
          if (that) {
            that.loadShow = false;
          }

          if (url == "Ca_AcProducts/GetAcProductListBySearch") {
            var res = res.data.Data;
            var listArr = [];
            if (
              that.pageData.postUrl == "Ca_AcProducts/GetAcProductListBySearch"
            ) {
              // 订购商品
              if (
                that.pageData.params.SearchProductType == 1 ||
                that.pageData.params.SearchProductType == 2 ||
                that.pageData.params.SearchProductType == 5 ||
                that.pageData.params.SearchProductType == 6 ||
                that.pageData.params.SearchProductType == 7 ||
                that.pageData.params.SearchProductType == 8
              ) {
                for (var i = 0; i < res.ProductInfo_Comm_List.length; i++) {
                  if (res.ProductInfo_Comm_List[i].ImgUrl != null) {
                    res.ProductInfo_Comm_List[
                      i
                    ].ImgUrl = res.ProductInfo_Comm_List[i].ImgUrl.split(
                      ","
                    )[0];
                  }
                }
                listArr = res.ProductInfo_Comm_List;
              } else if (that.pageData.params.SearchProductType == 3) {
                listArr = res.TopTenHotProductName_List;
              } else if (that.pageData.params.SearchProductType == 4) {
                listArr = res.ProductInfo_KeyWord_List;
              }
              that.ShenHeStatus = res.ShenHeStatus;
              util.setSto("ShenHeStatus", res.ShenHeStatus);
              that.IsADS = res.IsADS;
            } else {
              listArr = res.data.Data.infoList;
            }

            if (isFirst) {
              that.pageData.infoList = listArr;
              if (that.pageData.infoList.length < 4) {
                that.pageData.isLoading = false;
              }
            } else {
              that.pageData.infoList = that.pageData.infoList.concat(listArr);
            }
            that.pageData.TotalPage = res.TotalPage == 0 ? 1 : res.TotalPage;
            that.pageData.totalNum = res.TotalCount;
            if (that.pageData.params.CurrentPage <= that.pageData.TotalPage) {
              that.pageData.params.CurrentPage++;
            }

            for (let i in res) {
              if (
                i == "infoList" ||
                i == "StoreFromList" ||
                i == "CurrentPage" ||
                i == "TotalPage"
              ) {
              } else {
                that.pageData[i] = res[i];
              }
            }
            if (callback) {
              callback();
            }
          } else {
            resolve(res.data.Data);
          }
        } else {
          if (that) {
            that.loadShow = false;
            that.$parent.Loading(false);
          }

          if (that.surePaySuccess) {
            that.surePaySuccess = false;
          }
          reject(res.data.Data);
          Toast(res.data.Message);
        }
        // setTimeout(() => {
        // util.hideLoad()
        // }, 400);
      })
      .catch((err) => {
        if (that) {
          that.loadShow = false;
        }

        // util.hideLoad()
        reject(err);
        // Toast('网络异常')
      });
  });
}

function getListByPage(that, isFirst, callback) {
  that.pageData.params.CurrentPage = that.pageData.params.CurrentPage || 0;
  if (isFirst) {
    that.pageData.infoList = [];
    that.pageData.params.CurrentPage = 0;
  }
  // || that.pageData.isLoading
  if (that.pageData.params.CurrentPage >= that.pageData.TotalPage) {
    that.pageData.isLoading = false;
    that.loadShow = false;
  } else {
    that.pageData.isLoading = true;
    postNoLoading(
      that.pageData.postUrl,
      that.pageData.params,
      that,
      isFirst,
      callback
    );
  }
}

function postNoLoading(url, data = {}, that, isFirst, callback) {
  let Addurl = "";
  // if(url == 'Authorize/GetCustomerApplyInfo'){
  // 	Addurl = 'http://192.168.0.49:116/api/Authorize/GetCustomerApplyInfo';
  // }else{
  Addurl = basedata.postUrl + url;
  // }
  if (!!util.getStoObj("allinfo")) {
    data.PlatformType = util.getStoObj("allinfo").PlatformType;
    data.ADS_UserId = util.getStoObj("allinfo").ADS_UserId;
    // data.IsLogin = !!util.getStoObj('allinfo').Eshop_Mobile ? '1':'0';
    data.OrdHelperMemId = util.getStoObj("allinfo").OrdHelperMemId;
    data.OrdHelperToken = util.getStoObj("allinfo").OrdHelperToken;
    // data.QRcode_Type = 3;
    // data.ShareActivityId = 0;
    // data.ShareUserId = 0;
    if (url == "Ca_AcProducts/GetAcProductListBySearch") {
      data.ShopCode = util.getStoObj("allinfo").ShopCode;
      data.Mobile = util.getStoObj("allinfo").Eshop_Mobile;
    }
  }
  return new Promise((resolve, reject) => {
    // util.showLoad()
    axios
      .post(Addurl, data)
      .then((res) => {
        if (!!res.data.Data.NewToken) {
          var allinfo = util.getStoObj("allinfo");
          if (allinfo) {
            allinfo.OrdHelperToken = res.data.Data.NewToken;
          }
          util.setStoObj("allinfo", allinfo);
        } else if (!!res.data.NewToken) {
          var allinfo = util.getStoObj("allinfo");
          if (allinfo) {
            allinfo.OrdHelperToken = res.data.NewToken;
          }
          util.setStoObj("allinfo", allinfo);
        } else if (!!res.data.Data.OrdHelperToken) {
          var allinfo = util.getStoObj("allinfo");
          if (allinfo) {
            allinfo.OrdHelperToken = res.data.Data.OrdHelperToken;
          }
          util.setStoObj("allinfo", allinfo);
        }
        if (res.data.ResultType === 1) {
          if (that) {
            that.loadShow = false;
          }

          if (url == "Ca_AcProducts/GetAcProductListBySearch") {
            var res = res.data.Data;
            var listArr = [];
            if (
              that.pageData.postUrl == "Ca_AcProducts/GetAcProductListBySearch"
            ) {
              // 订购商品
              if (
                that.pageData.params.SearchProductType == 1 ||
                that.pageData.params.SearchProductType == 2 ||
                that.pageData.params.SearchProductType == 5 ||
                that.pageData.params.SearchProductType == 6 ||
                that.pageData.params.SearchProductType == 7 ||
                that.pageData.params.SearchProductType == 8
              ) {
                for (var i = 0; i < res.ProductInfo_Comm_List.length; i++) {
                  if (res.ProductInfo_Comm_List[i].ImgUrl != null) {
                    res.ProductInfo_Comm_List[
                      i
                    ].ImgUrl = res.ProductInfo_Comm_List[i].ImgUrl.split(
                      ","
                    )[0];
                  }
                }
                listArr = res.ProductInfo_Comm_List;
              } else if (that.pageData.params.SearchProductType == 3) {
                listArr = res.TopTenHotProductName_List;
              } else if (that.pageData.params.SearchProductType == 4) {
                listArr = res.ProductInfo_KeyWord_List;
              }
              that.ShenHeStatus = res.ShenHeStatus;
              util.setSto("ShenHeStatus", res.ShenHeStatus);
              that.IsADS = res.IsADS;
            } else {
              listArr = res.data.Data.infoList;
            }

            if (isFirst) {
              that.pageData.infoList = listArr;
              if (listArr.length < 4) {
                that.pageData.isLoading = false;
              }
            } else {
              that.pageData.infoList = that.pageData.infoList.concat(listArr);
            }
            that.pageData.TotalPage = res.TotalPage == 0 ? 1 : res.TotalPage;
            that.pageData.totalNum = res.TotalCount;
            if (that.pageData.params.CurrentPage <= that.pageData.TotalPage) {
              that.pageData.params.CurrentPage++;
            }

            for (let i in res) {
              if (
                i == "infoList" ||
                i == "StoreFromList" ||
                i == "CurrentPage" ||
                i == "TotalPage"
              ) {
              } else {
                that.pageData[i] = res[i];
              }
            }
            if (callback) {
              callback();
            }
          } else {
            resolve(res.data.Data);
          }
        } else {
          that.loadShow = false;
          that.$parent.Loading(false);
          reject(res.data.Data);
          Toast(res.data.Message);
        }
        // setTimeout(() => {
        // util.hideLoad()
        // }, 400);
      })
      .catch((err) => {
        if (that) {
          that.loadShow = false;
        }
        // util.hideLoad()
        reject(err);
        // Toast('网络异常')
      });
  });
}
async function postNoLoadingTwo(url, data = {}, that, isFirst, callback) {
  let Addurl = "";
  // if(url == 'Authorize/GetCustomerApplyInfo'){
  // 	Addurl = 'http://192.168.0.49:116/api/Authorize/GetCustomerApplyInfo';
  // }else{
  // Addurl = sessionStorage.getItem('QPT_DomainUrl') + url;
  // }
  axios.defaults.headers.post["Content-Type"] =
    "application/x-www-form-urlencoded";
  return await new Promise((resolve, reject) => {
    axios
      .request({
        url,
        baseURL: sessionStorage.getItem("QPT_DomainUrl"),
        headers: {
          Token: sessionStorage.getItem("QPT_UserToken"),
          "content-type": "application/x-www-form-urlencoded",
        },
        method: "POST",
        data: qs.stringify(data),
      })
      .then((res) => {
        if (res.data.ResultType === 1) {
          resolve(res.data);
        } else {
          resolve(res.data);
          Toast(res.data.Reason);
        }
      })
      .catch((err) => {
        that.loadShow = false;
        reject(err);
      });
  });
}

async function postNoLoadingThere(url, data = {}, that, isFirst, callback) {
  return await new Promise((resolve, reject) => {
    axios
      .request({
        url,
        baseURL: sessionStorage.getItem("QPT_DomainUrl"),
        headers: {
          Token: sessionStorage.getItem("QPT_UserToken"),
        },
        method: "POST",
        data,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        that.loadShow = false;
        reject(err);
      });
  });
}

async function reqPost(url, data = {}, postimg = false,isToast = true) {
  if (!postimg) {
    // console.log(qs.stringify(data), 'qs')
  }
  if (!data.DMSCode) {
    data.DMSCode = api.getDMSCode();
  }
  if (!data.ShopCode) {
    data.ShopCode = api.getShopCode();
  }
  if(localStorage.getItem('urlQuery')){
    
    let QPT_UserInfo = JSON.parse(localStorage.getItem('urlQuery')).QPT_UserInfo;
    let IsTypr = JSON.parse(QPT_UserInfo).IsTypr;
    data.IsTypr = IsTypr || "";
    if(data.IsTypr == 1){
      data.CustomerID = localStorage.getItem("CustomerID")||"";
      data.OrgId = localStorage.getItem('OrgId')||"";
    }
    
  }
  
  let req = () =>
    axios.request({
      url,
      // baseURL: basedata.postUrlNew,
      headers: {
        Token: sessionStorage.getItem("QPT_UserToken") || "",
        "content-type": postimg
          ? "multipart/form-data"
          : "application/x-www-form-urlencoded",
      },
      method: "POST",
      data: postimg ? data : qs.stringify(data),
    });

  return await req()
    .then((res) => {
      if (
        !res.data.Data &&
        res.data.ResultCode == 1001 &&
        res.data.Reason == "还未登录，请登录"
      ) {
        if (api.getShopCode()) {
          // 测试流程
          //判断重新登录的请求是否已经发出
          let relogin_status = sessionStorage.getItem("relogin_status");
          if (relogin_status) {
            return new Promise((resolve, reject) => {
              setTimeout(() => resolve(req()), 1000); //延迟1s后重试
            });
          } else {
            sessionStorage.setItem("relogin_status", true);
            return api.loginQPT().then(() => {
              sessionStorage.removeItem("relogin_status");
              return req();
            });
          }
        } else {
          // 小程序标准流程
          console.log("小程序中重新登录");
          // wx.miniProgram.postMessage({ data:{goLogin: 'true'} })
          Toast(res.data.Reason);
          // 登录过期
          // wx.miniProgram.redirectTo({
          //   url: "/pages/login/first/first",
          // });
          return res;
        }
      }else if(!res.data.Data && res.data.ResultCode == 0 && res.data.Reason == "登录过期"){
        Toast(res.data.Reason);
        // setTimeout(()=>{
        //   wx.miniProgram.redirectTo({
        //     url: "/pages/login/first/first",
        //   });
        // },500)
        return res;
      } else {
        return res;
      }
    })
    .then((res) => {
      if (res.data.ResultType === 1) {
        return res.data;
      } else {
        if(isToast){
          setTimeout(() => {
            Toast(res.data.Reason);
          }, 500);
        }
        
        return Promise.reject(res.data.Reason);
      }
    });
}
// 控制中心
async function ControlCenterRequest(url, params = {}) {
  return await new Promise((resolve, reject) => {
    axios
      .request({
        url,
        baseURL: basedata.CONTROL_CENTER_URL,

        method: "POST",
        params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
/**
 * 支付请求
 * @param {*} url
 * @param {*} data
 */
let payforReqPost = async function(url, data) {
  return await new Promise((resolve, reject) => {
    console.log(url);
    axios
      .request({
        url,
        baseURL: basedata.PAY_FOR_URL,
        method: "POST",
        data,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

let getListByPageNew = function(that, isFirst, callback) {
  that.pageData.params.CurrentPage = that.pageData.params.CurrentPage || 1;
  that.pageData.params.PageSize = that.pageData.params.PageSize || 20;
  if (isFirst) {
    that.pageData.infoList = [];
    that.pageData.params.CurrentPage = 0;
    that.pageData.params.TotalPage = 0;
    that.pageData.params.totalNum = 0;
    that.pageData.params.SalesOrderCode = "";
  }

  if (
    !isFirst &&
    (that.pageData.params.CurrentPage > that.pageData.TotalPage ||
      that.pageData.isLoading)
  ) {
    that.$parent.Loading(false);
    return;
  } else {
    that.$parent.Loading(true);
    that.pageData.isLoading = true;
    let pageRequestParams = {
      UserId: util.getStoObj("allinfo").UserId,
      PageNo: that.pageData.params.CurrentPage,
      PageSize: that.pageData.params.PageSize,
    };
    if (!that.queryData.DMSCode) {
      pageRequestParams.DMSCode = api.getDMSCode();
    }
    if (!that.queryData.ShopCode) {
      pageRequestParams.ShopCode = api.getShopCode();
    }

    axios
      .request({
        url: that.pageData.postUrl,
        baseURL: basedata.postUrlNew,
        headers: {
          Token: sessionStorage.getItem("QPT_UserToken"),
          "content-type": "application/x-www-form-urlencoded",
        },
        method: "POST",
        data: qs.stringify(
          Object.assign({}, that.queryData, pageRequestParams)
        ),
      })
      .then((res) => {
        res = res.data;
        that.pageData.isLoading = false;
        that.$parent.Loading(false);
        let listArr = [];

        listArr = res.Data || [];

        if (isFirst) {
          that.pageData.infoList = listArr;
        } else {
          that.pageData.infoList = that.pageData.infoList.concat(listArr);
        }
        that.pageData.TotalPage = Math.ceil(
          res.Count / that.pageData.params.PageSize
        );
        that.pageData.totalNum = res.Count;

        if (that.pageData.params.CurrentPage <= that.pageData.TotalPage) {
          that.pageData.params.CurrentPage++;
        }

        if (callback) {
          callback();
        }
      });
  }
};
// 上传图片获取vin码
let getVinCode = async function(url, data) {
  data = data || {};
  return await new Promise((resolve, reject) => {
    axios.request({
      url,
      baseURL: basedata.SJT_URL,
      method: "POST",
      headers: {
        "AUTH_AUTO_TOKEN": 'ftservice_s20200518174201',
        "content-type": "application/json;charset=UTF-8"
      },
      data
    }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err);
    });
  });
};

export default {
  post,
  postTwo,
  postNoLoading,
  postNoLoadingTwo,
  postNoLoadingThere,
  getListByPage,
  reqPost,
  getListByPageNew,
  ControlCenterRequest,
  payforReqPost,
  getVinCode
};
